import React, { useEffect, useState } from 'react';
import { Modal, Form, Radio, Checkbox, Grid } from 'semantic-ui-react';
import './massUploadModal.css';
import { apiGet, apiPost } from '../services/apiClient';
import Dropdown from '../components/Dropdown';
import ConfirmModal from '../components/Modals/ConfirmModal';
import { getRoles } from '../services/userRights';

const MassOrderModal = ({ isOpen, ids, carriers, onComplete, onClose }) => {
    const [selectionType, setSelectionType] = useState('0');
    const [carrierId, setCarrierId] = useState(null);
    const [isCreatedByManagedPaid, setIsCreatedByManagedPaid] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [confirmModal, setConfirmModal] = useState(null);

    const isCoordinator = (getRoles() || []).includes('Coordinator');

    const selectionTypes = [
        {
            text: 'Заказать самый дешёвый вариант доставки',
            value: '0'
        },
        {
            text: 'Заказать самый быстрый вариант доставки',
            value: '1'
        },
        {
            text: 'Заказать самый дешёвый вариант доставки у выбранного перевозчика',
            value: '2'
        },
        {
            text: 'Заказать самый быстрый вариант доставки у выбранного перевозчика',
            value: '3'
        }
    ];

    useEffect(() => {
        if (selectionType === '0' || selectionType === '1') {
            setCarrierId(null);
        }
    }, [selectionType]);

    const clearData = () => {
        setSelectionType('0');
        setCarrierId(null);
        setIsCreatedByManagedPaid(false);
        setErrors({});
    };

    const handleClose = () => {
        clearData();
        onClose();
    };

    const handleOrder = () => {
        setDisabled(true);
        setErrors({});
        apiPost('massorder/request', {
            ids,
            selectionType,
            carrierId,
            isCreatedByManagedPaid
        })
            .then(() => {
                setDisabled(false);
                onComplete();
            })
            .catch((err) => {
                setDisabled(false);
                setErrors(err.messages || {});
            });
    };

    return (
        <Modal
            open={isOpen}
            closeIcon
            size="small"
            onClose={handleClose}
        >
            <Modal.Header>
                Массовый заказ отправлений
            </Modal.Header>
            <Modal.Content className='modal__content'>
                <Form>
                    <Grid>
                        <Grid.Row columns={16}>
                            <Grid.Column width={16}>
                                <Form.Field error={errors.selectionType}>
                                    <label>
                                        Выберите какой тариф заказать: <span className="text-red">*</span>
                                    </label>
                                    {selectionTypes.map((option) => (
                                        <div>
                                            <Radio
                                                label={option.text}
                                                value={option.value}
                                                checked={selectionType === option.value}
                                                onChange={(e, { value }) => setSelectionType(value)}
                                                disabled={disabled}
                                            />
                                        </div>
                                    ))}
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={16}>
                            <Grid.Column width={16}>
                                <Form.Field error={errors.carrierId}>
                                    <label>
                                        Транспортная компания
                                    </label>
                                    <Dropdown
                                        onChange={(e, { value }) => setCarrierId(value)}
                                        disabled={disabled || selectionType === '0' || selectionType === '1'}
                                        value={carrierId}
                                        options={carriers.map((c) => ({ value: c.id, text: c.name }))}
                                    />
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>
                        {isCoordinator && <Grid.Row columns={16}>
                            <Grid.Column width={16}>
                                <Form.Field>
                                    <Checkbox
                                        checked={isCreatedByManagedPaid}
                                        onChange={(e, { checked }) => setIsCreatedByManagedPaid(checked)}
                                        disabled={disabled}
                                        label={'Выставить клиенту сумму за создание заказов клиентским менеджером по каждой посылке'}
                                    />
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>}
                    </Grid>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <button
                    className="ui primary button"
                    onClick={handleOrder}
                    disabled={disabled}
                >
                    Заказать
                </button>
                <button
                    className="ui button"
                    onClick={handleClose}
                    disabled={disabled}
                >
                    Отмена
                </button>
            </Modal.Actions>
        </Modal>
    );
};

export default MassOrderModal;




// WEBPACK FOOTER //
// ./App/modals/massOrderModal.jsx